// extracted by css-extract-rspack-plugin
export default {"a0":"index-cls1_wps","cls1":"index-cls1_Ms_","cls2":"index-cls2_G4p index-cls1_Ms_"};